import { render, staticRenderFns } from "./decoration2.vue?vue&type=template&id=239f5691&scoped=true"
import script from "./decoration2.vue?vue&type=script&lang=js"
export * from "./decoration2.vue?vue&type=script&lang=js"
import style0 from "./decoration2.vue?vue&type=style&index=0&id=239f5691&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239f5691",
  null
  
)

export default component.exports